import CanvasRenderer from './canvas_renderer';

export default class Alignment {
  constructor(canvas) {
    this.canvas = canvas;
    this.canvasRenderer = new CanvasRenderer(canvas);
  }

  align(direction) {
    this[`align${direction}`]();
  }

  alignLeft() {
    const positions = this.canvas.getActiveObjects();
    if (positions.length <= 1) return;

    const alignTo = this.getMin(positions, 'left');

    this.alignPositions(positions, 'left', alignTo);
    this.canvasRenderer.refreshSelections(positions);
  }

  alignRight() {
    const positions = this.canvas.getActiveObjects();
    if (positions.length <= 1) return;

    const alignTo = this.getMax(positions, 'left');

    this.alignPositions(positions, 'left', alignTo);
    this.canvasRenderer.refreshSelections(positions);
  }

  alignCenterVertical() {
    const positions = this.canvas.getActiveObjects();
    if (positions.length <= 1) return;

    const left = this.getMin(positions, 'left');
    const right = this.getMax(positions, 'left');
    const alignTo = left + ((right - left) / 2);

    this.alignPositions(positions, 'left', alignTo);
    this.canvasRenderer.refreshSelections(positions);
  }

  alignTop() {
    const positions = this.canvas.getActiveObjects();
    if (positions.length <= 1) return;

    const alignTo = this.getMin(positions, 'top');

    this.alignPositions(positions, 'top', alignTo);
    this.canvasRenderer.refreshSelections(positions);
  }

  alignBottom() {
    const positions = this.canvas.getActiveObjects();
    if (positions.length <= 1) return;

    const alignTo = this.getMax(positions, 'top');

    this.alignPositions(positions, 'top', alignTo);
    this.canvasRenderer.refreshSelections(positions);
  }

  alignCenterHorizontal() {
    const positions = this.canvas.getActiveObjects();
    if (positions.length <= 1) return;

    const top = this.getMin(positions, 'top');
    const bottom = this.getMax(positions, 'top');
    const alignTo = top + ((bottom - top) / 2);

    this.alignPositions(positions, 'top', alignTo);
    this.canvasRenderer.refreshSelections(positions);
  }

  alignPositions(positions, axis, value) {
    positions.forEach(pos => {
      const initialLeft = pos.left;
      const initialTop = pos.top;

      pos[axis] = value;
      pos.setCoords()

      const { left, top } = pos;
      const leftOffset = left - initialLeft;
      const topOffset = top - initialTop;

      pos.fire('selection:moved', { leftOffset, topOffset });
    });
  }

  getMin(positions, axis) {
    return Math.min(...positions.map(pos => pos[axis]));
  }

  getMax(positions, axis) {
    return Math.max(...positions.map(pos => pos[axis]));
  }
}
